/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EXPANDABLE SECTION - CONFIG TOGGLE : STYLES --------------- ++++++++++ */
export default theme => ({
  configtoggle: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    gap: props => props.gap ? `${props.gap}px` : '24px',
    '& .header': {
      display: 'flex',
      flexDirection: 'column',
      gap: pxToEm(8),
      '& .toggle': {
        display: 'flex',
        gap: pxToEm(16),
        '& h3.title': {
          fontWeight: 500,
          fontSize: pxToEm(16)
        },
      },
      '& p.description': {
        // color: '#ccd1e6',
        fontSize: pxToEm(13),
        lineHeight: pxToEm(17),
        fontStyle: 'italic',
        paddingLeft: pxToEm(72)
      }
    },
    '& > .content': {
      display: 'flex',
      flexDirection: 'column',
      gap: pxToEm(16),
      paddingLeft: props => props.indented === false ? pxToEm(12) : pxToEm(24),
      borderLeft: props => props.indented === false ? 'none' : '2px solid #ccd1e6',
      '&.checked-false': {
        opacity: 0.4,
        pointerEvents: 'none'
      }
    }
  }
});
